module.exports = __webpack_public_path__ + "img/zeitstrahl_punkte_horizontal.07c93c02.svg";